import React from 'react';
import '../App.css';

import { Navbar, Bq_header, Bq_blogs, Bq_ideas, Bq_libros} from '../container';
import FooterPrime from '../container/Footer/Footer';

import { useAxios } from '../hooks/useAxios';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BusquedaG = () => {
    const { words } = useParams();
    const [t, i18n] = useTranslation("global");
    const { data, isLoading, error } = useAxios(`/search?words=${ words }&lang=${ i18n.language }`);
    const { blogResult, booksResult, ideasResult } = !!data && data;

    

    return (
      <div class="App_DB">
            <Navbar/>
            <Bq_header titulo={ words } blogs={blogResult ? blogResult.total : 0} ideas={ideasResult ? ideasResult.total : 0} libros={booksResult ? booksResult.total : 0}/>
            <Bq_blogs contenido={ blogResult }/>
            <Bq_ideas contenido={ideasResult}/>
            <Bq_libros contenido={ booksResult } />
            <FooterPrime/>
      </div>
    )
  }
  
  export default BusquedaG
  